<script>
import {
  Stage as VStage,
  Layer as VLayer,
  Group as VGroup,
  Rect as VRect,
  Text as VText,
  Line as VLine,
  Label as VLabel,
  Tag as VTag
} from 'vue-konva';

export default {
  components: {
    VStage,
    VLayer,
    VGroup,
    VRect,
    VText,
    VLine,
    VLabel,
    VTag
  },

  props: {
    stuff: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    var width = 1200;
    var height = 600;

    return {
      data: {},
      stageSize: {
        width: width,
        height: height
      },
      gridSize: 10,
      background: {
        x: 0,
        y: 0,
        width: width,
        height: height,
        fill: '#f9fafb',
        stroke: '#111827',
        strokeWidth: 3
      },
      tooltip: {
        visible: false,
        x: 0,
        y: 0,
        text: '',
        direction: 'down'
      },
      sample: {
        model: {},
        shape_name: "rectangle",
        group: {
          x: 90,
          y: 90,
          offsetX: 90 / 2,
          offsetY: 90 / 2,
          rotation: 45,
          draggable: true,
          dragBoundFunc: (pos) => {
            const stageWidth = this.stageSize.width
            const stageHeight = this.stageSize.height
            const grid = this.gridSize

            const halfW = 90 / 2
            const halfH = 90 / 2

            // limit ke canvas
            let limitedX = Math.max(
              halfW,
              Math.min(stageWidth - halfW, pos.x)
            )
            let limitedY = Math.max(
              halfH,
              Math.min(stageHeight - halfH, pos.y)
            )

            // snap ke grid
            const snap = (v) => Math.round(v / grid) * grid

            return {
              x: snap(limitedX),
              y: snap(limitedY)
            }
          }
        },
        stuff: {
          x: 0,
          y: 0,
          width: 40,
          height: 20,
          fill: '#' + "371D10",
          stroke: 'black',
          strokeWidth: 1,
          cornerRadius: 2,
        },
        text: {
          text: "VP001",
          x: 0,
          y: 0,
          width: 40,
          height: 20,
          align: 'center',
          verticalAlign: 'middle',
          fontSize: 10,
          fill: '#' + "FFFFFF",
          fontStyle: 'normal',
          listening: false
        },
      }
    }
  },

  computed: {
    mappedStuff() {
      return [...this.stuff]
        .sort((a, b) => a.number - b.number)
        .map(x => ({
          model: x,
          shape: x.shape,
          group: {
            x: x.x,
            y: x.y,
            offsetX: x.width / 2,
            offsetY: x.height / 2,
            rotation: x.rotation,
            draggable: (this.$ac.hasAccess('stuff_full_access') || (this.$ac.hasAccess('stuff_create') && this.$ac.hasAccessStore(x.store_id))),
            dragBoundFunc: (pos) => {
              const stageWidth = this.stageSize.width
              const stageHeight = this.stageSize.height
              const grid = this.gridSize

              const halfW = x.width / 2
              const halfH = x.height / 2

              // limit ke canvas
              let limitedX = Math.max(
                halfW,
                Math.min(stageWidth - halfW, pos.x)
              )
              let limitedY = Math.max(
                halfH,
                Math.min(stageHeight - halfH, pos.y)
              )

              // snap ke grid
              const snap = (v) => Math.round(v / grid) * grid

              return {
                x: snap(limitedX),
                y: snap(limitedY)
              }
            }
          },
          stuff: {
            x: 0,
            y: 0,
            width: x.width,
            height: x.height,
            fill: '#' + x.color,
            stroke: 'black',
            strokeWidth: 1,
            cornerRadius: 2,
          },
          text: {
            text: x.number,
            x: 0,
            y: 0,
            width: x.width,
            height: x.height,
            align: 'center',
            verticalAlign: 'middle',
            fontSize: 10,
            fill: '#' + x.text_color,
            fontStyle: 'normal',
            listening: false
          }
        }));
    },
    gridLines() {
      const lines = [];
      const { width, height } = this.stageSize;
      const size = this.gridSize;

      for (let i = 0; i <= width; i += size) {
        lines.push({
          points: [i, 0, i, height],
          stroke: '#e5e7eb',
          strokeWidth: 1
        });
      }

      for (let j = 0; j <= height; j += size) {
        lines.push({
          points: [0, j, width, j],
          stroke: '#e5e7eb',
          strokeWidth: 1
        });
      }

      return lines;
    }
  },

  methods: {
    async move() {
      var vm = this;
      vm.$loading.on('room_detail_stuff_move');

      try {
        var postData = vm._createPostData(vm.data);
        await this.$api.Stuff.move(postData);
      } catch (err) {
        vm.$flash.error(err.response.data.message);
      }
      vm.$emit('onRefresh', true);
      vm.$loading.off('room_detail_stuff_move');
    },
    _createPostData: function (data) {
      return data;
    },
    onDrag(tr, $event) {
      var vm = this;

      this.tooltip.visible = false;

      var data = tr.model;
      data.x = $event.target.x();
      data.y = $event.target.y();

      vm.data = data;

      vm.move();
    },
    onClickStuff(tr, $event) {
      $event.cancelBubble = true;

      const group = $event.target.getParent();
      const stage = group.getStage();
      const box = group.getClientRect({ relativeTo: stage });

      const stageWidth = this.stageSize.width;
      const stageHeight = this.stageSize.height;

      // =========================
      // Tentukan atas / bawah
      // =========================
      const spaceAbove = box.y;
      const spaceBelow = stageHeight - (box.y + box.height);
      const showAbove = spaceAbove > spaceBelow;

      // posisi awal (center)
      const horizontalOffset = 30;
      this.tooltip.x = box.x + box.width / 2 + horizontalOffset;

      const verticalOffset = 30;

      if (showAbove) {
        // tooltip di atas → turunkan sedikit
        this.tooltip.y = box.y + verticalOffset;
        this.tooltip.direction = 'down';
      } else {
        this.tooltip.y = box.y + box.height;
        this.tooltip.direction = 'up';
      }

      var label = (tr.model.ref_no_external ? tr.model.ref_no_external : tr.model.ref_no);

      this.tooltip.text = `${label}`;
      this.tooltip.visible = true;

      this.$nextTick(() => {
        const labelNode = this.$refs.tooltipLabel.getNode();

        const width = labelNode.width();
        const height = labelNode.height();

        // set offset dulu
        labelNode.offsetX(width / 2);
        labelNode.offsetY(
          this.tooltip.direction === 'down' ? height : 0
        );

        // =========================
        // CLAMP HORIZONTAL (FINAL)
        // =========================
        let newX = this.tooltip.x;

        const minX = width / 2;
        const maxX = stageWidth - width / 2;

        if (newX < minX) newX = minX;
        if (newX > maxX) newX = maxX;

        this.tooltip.x = newX;

        // =========================
        // CLAMP VERTICAL (FINAL)
        // =========================
        let newY = this.tooltip.y;

        if (this.tooltip.direction === 'down') {
          // tooltip di atas group
          if (newY - height < 0) {
            newY = height;
          }
        } else {
          // tooltip di bawah group
          if (newY + height > stageHeight) {
            newY = stageHeight - height;
          }
        }

        this.tooltip.y = newY;
      });
    },
    onStageClick(e) {
      if (e.target === e.currentTarget) {
        this.tooltip.visible = false;
      }
    }
  }
}
</script>

<template>
  <v-stage :config="stageSize" @click="onStageClick">
    <v-layer>
      <v-rect :config="background" @click="onStageClick" />
      <v-line v-for="(line, i) in gridLines" :key="'grid-' + i" :config="line" :listening="false" />
      <v-group v-for="(tr, index) in mappedStuff" :key="'stuff-' + index" :config="tr.group"
        @dragend="onDrag(tr, $event)" @click="onClickStuff(tr, $event)">
        <v-rect :config="tr.stuff" />
        <v-text :config="tr.text" />
      </v-group>

      <v-label ref="tooltipLabel" :config="{
        x: tooltip.x,
        y: tooltip.y,
        visible: tooltip.visible
      }">
        <v-tag fill="black" :cornerRadius="4" :pointerDirection="tooltip.direction" />
        <v-text :config="{
          text: tooltip.text,
          fontSize: 12,
          padding: 6,
          fill: 'white'
        }" />
      </v-label>
      <!-- <v-group :key="'sample-' + index" :config="sample.group" @dragend="onDrag(sample, $event)">
        <v-rect :config="sample.stuff" />
        <v-text :config="sample.text" />
      </v-group> -->
    </v-layer>
  </v-stage>
</template>